import { object, string, boolean } from 'decoders';

export interface UserPreference {
  setting: string;
  enabled: boolean;
  label: string;
}

export const userPreferenceDecoder = object({
  setting: string,
  enabled: boolean,
  label: string
});
